module.exports = __webpack_public_path__ + "static/media/leopard_head_orientation_left.8b9de8be.jpeg";